import objectIsEmpty from "common/utils/objectIsEmpty";

export function isEmpty(value: unknown) {
  if (typeof value === "undefined") {
    return true;
  }
  if (typeof value === "string" && !value) {
    return true;
  }
  if (typeof value === "object") {
    if (objectIsEmpty(value)) {
      return true;
    }
    if (Array.isArray(value) && !value.length) {
      return true;
    }
  }

  // All other types will be defined
  return false;
}
